import {Button, ButtonProps, Circle} from '@chakra-ui/react';
import {colors} from 'components/providers';
import {FC} from 'react';
import NextImageUI from 'ui/NextImage';

interface Props extends ButtonProps {
  filtersNumber?: number;
  id?: string;
  onActive?: (value: string) => void;
  activeButton?: string;
  icon?: string;
}

export const FilterButtonCount: FC<Props> = ({
  children,
  filtersNumber,
  id,
  onActive,
  activeButton,
  icon,
  ...buttonProps
}) => {
  const setActive = () => {
    id && onActive && onActive(id);
  };

  const isActive = !!filtersNumber && activeButton === id;
  const filterCount = filtersNumber && filtersNumber < 99 ? filtersNumber : 99;
  const linkProps = id
    ? {
        as: 'a',
        href: `#${id}`,
      }
    : {};

  const activeStyles = {
    bg: colors.pink,
    _hover: {
      bg: isActive && colors.pink,
    },
    _active: {
      bg: isActive && colors.pink,
    },
    border: 'none',
    color: colors.white,
    img: {filter: 'invert(1)'},
  };

  return (
    <Button
      sx={isActive ? activeStyles : {}}
      {...(linkProps as ButtonProps)}
      iconSpacing="10px"
      id={`#${id}`}
      border="1px solid"
      borderColor={colors.borderGray}
      fontSize={['16px', '18px']}
      minH="45px"
      px={['10px', 'auto']}
      cursor="pointer"
      _focus={{borderColor: colors.borderGray}}
      onClick={setActive}
      leftIcon={
        !!filtersNumber ? (
          <Circle
            size={filtersNumber > 9 ? '25px' : '20px'}
            border="1px solid"
            fontSize={['9px', '12px']}
            fontWeight={600}
          >
            {filterCount}
          </Circle>
        ) : (
          <>{icon ? <NextImageUI src={icon} width={31} height={31} alt="Filter icon" /> : null}</>
        )
      }
      rightIcon={<NextImageUI src="/icons/arrow-down-fill.svg" width={15} height={14} alt="Arrow down" />}
      {...buttonProps}
    >
      {children}
    </Button>
  );
};
